import React, { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { setDangerouslyInnerHtml } from "../../helpers/set-inner-html";
import { moduleSettings } from "../../stores/module-settings.store";
import moment from "moment-timezone";
import { getLanguageSwitcherService } from "../../services/language-switcher.service";

const UpdateBannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: -32px;
  margin-bottom: 32px;
  padding: 4px 0;
  background-color: ${(props) => props.theme.informationTextBackgroundColor};
`;

const UpdateBannerDef = () => {
  const { t } = useTranslation();
  moment.locale(getLanguageSwitcherService().localeForMoment());
  const updateFromBooking = moduleSettings.updateFromBooking;
  const count = updateFromBooking.booked_persons_number;
  const childrenNumber = updateFromBooking.children_number;
  const timezone = moduleSettings.restaurantTimezone;
  const date = moment(updateFromBooking.booking_time)
    .tz(timezone)
    .format("D MMMM");
  const hour =
    moment(updateFromBooking.booking_time).tz(timezone).format("HH") +
    "h" +
    moment(updateFromBooking.booking_time).format("mm");

  const setMessage = (): string => {
    switch (childrenNumber) {
      case 0:
        return count! > 1
          ? "instabook.bookings.update_banner.other"
          : "instabook.bookings.update_banner.one";
      default:
        return "instabook.bookings.update_banner_with_children";
    }
  };

  const setParams = () => {
    switch (childrenNumber) {
      case 0:
        return {
          count,
          date,
          hour,
        };
      default:
        const children =
          childrenNumber! > 1
            ? childrenNumber + " " + t("instabook.common.children")
            : 1 + " " + t("instabook.common.child");
        return {
          count,
          children,
          date,
          hour,
        };
    }
  };

  return (
    <UpdateBannerWrapper data-test="update-banner">
      <span
        dangerouslySetInnerHTML={setDangerouslyInnerHtml(
          t,
          setMessage(),
          setParams()
        )}
      />
    </UpdateBannerWrapper>
  );
};
export const UpdateBanner = memo(UpdateBannerDef);
